var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen justify-content-center align-items-center"},[_c('b-spinner',{staticClass:"spinner",staticStyle:{"width":"20rem","height":"20rem","color":"white"},attrs:{"label":"Large Spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }